import peetLogo from './components/icons/peet-logo';
import mirvacLogo from './components/icons/mirvac-logo';
import areaIcon from './components/icons/area-icon';
import bathsIcon from './components/icons/baths-icon';
import bedsIcon from './components/icons/beds-icon';
import carsIcon from './components/icons/cars-icon';
import sizeIcon from './components/icons/size-icon';
import displayPin from './components/icons/display-pin';
import emailCircleIcon from './components/icons/email-circle-icon';
import facebookCircleIcon from './components/icons/facebook-circle-icon';
import facebookYouTubeCircleIcon from './components/icons/facebook-youtube-circle-icon';
import twitterCircleIcon from './components/icons/twitter-circle-icon';
import shareCircleIcon from './components/icons/share-circle-icon';
import saveCircleIcon from './components/icons/save-circle-icon';
import facebookSquareIcon from './components/icons/facebook-square-icon';
import communityIcon from './components/icons/community-icon';
import childcareIcon from './components/icons/childcare-icon';
import trainsIcon from './components/icons/trains-icon'; 
import shoppingIcon from './components/icons/shopping-icon';
import sportIcon from './components/icons/sport-icon';
import schoolIcon from './components/icons/school-icon';
import instagramIcon from './components/icons/instagram-icon';
import twitterIcon from './components/icons/twitter-icon';
import facebookIcon from './components/icons/facebook-icon';
import favouriteIcon from './components/icons/favourite-icon';
import checkboxIcon from './components/icons/checkbox-icon';
import levelIcon from './components/icons/level-icon';
import arrowIcon from './components/icons/arrow-icon';
import closeIcon from './components/icons/close-icon';
import emailIcon from './components/icons/email-icon';
import visitIcon from './components/icons/visit-icon';
import chatIcon from './components/icons/chat-icon';
import callIcon from './components/icons/call-icon';
import pinIcon from './components/icons/pin-icon';
import searchIcon from './components/icons/search-icon';
import removeIcon from './components/icons/remove-icon';
import pdfIcon from './components/icons/pdf-icon';
import socialIconInsta from './components/icons/social-icon-instagram';
import socialIconFacebook from './components/icons/social-icon-facebook';
import socialIconLinkedIn from './components/icons/social-icon-linkedin';
import socialIconYouTube from './components/icons/social-icon-youtube';

$(() => {
    mirvacLogo(); 
    peetLogo();
  areaIcon();
  bathsIcon();
  bedsIcon();
  carsIcon();
  sizeIcon();
  displayPin();
  emailCircleIcon();
  facebookCircleIcon();
  facebookYouTubeCircleIcon();
  twitterCircleIcon();
  shareCircleIcon();
  saveCircleIcon();
  facebookSquareIcon();
  communityIcon();
  childcareIcon();
  trainsIcon();
  shoppingIcon();
  sportIcon();
  schoolIcon();
  instagramIcon();
  twitterIcon();
  favouriteIcon();
  checkboxIcon();
  levelIcon();
  arrowIcon();
  closeIcon();
  emailIcon();
  facebookIcon();
  visitIcon();
  chatIcon();
  callIcon();
  pinIcon();
  searchIcon();
  removeIcon();
  pdfIcon();
  socialIconInsta();
  socialIconFacebook();
  socialIconLinkedIn();
  socialIconYouTube();
});
